import { ButtonProps } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { Button } from 'shared/components/Button';

type ButtonLinkProps = {
  children: React.ReactNode;
  to: string;
  state?: any;
} & ButtonProps;

const ButtonLink = ({ children, to, state, ...props }: ButtonLinkProps) => {
  return (
    <Link to={to} state={state}>
      <Button {...props}>{children}</Button>
    </Link>
  );
};

export default ButtonLink;
